<template>
  <div class="grid-x margin-bottom-m">
    <h3 class="cell small-6">
      {{ title }}
    </h3>
    <button
      v-if="linkUrl"
      class="cell small-6 link"
    >
      <span
        class="secondary-cta"
        @click="followLink"
      >{{ linkName }}</span>
    </button>
  </div>
  <ProsContentCollectionHeroImage
    :recommendation-data="recommendationData"
    :use-wish-list="useWishList"
  />
  <ProsCarousel
    :config-data="getConfigData"
    @dataLoadStatusEvent="(e) => $emit('dataLoadStatusEvent', e)"
  />
</template>

<script>
import ProsContentCollectionHeroImage from '../ProsContentCollection/ProsContentCollectionHeroImage';
import ProsCarousel from '../ProsCarousel/ProsCarousel';
import constants from '../../utils/constants';
import { contentlinkClickEventTag } from '../../analytics/analyticsEvent';

const { SMALL, MEDIUM, LARGE } = constants.BREAK_POINT_TYPE;

export default {
  name: 'ProsContentCarousel',
  components: {
    ProsContentCollectionHeroImage,
    ProsCarousel,
  },
  props: {
    configData: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['dataLoadStatusEvent'],
  data() {
    return {
      impressionData: {
        media_type: 'PROS:Collections',
        content_position: 'r99s99',
      },
      numberOfItems: this.configData.numberOfItems || {
        [SMALL]: 2.5,
        [MEDIUM]: 5.5,
        [LARGE]: 5.25,
      },
      title: this.configData.title,
      linkName: this.configData.linkName || 'Similar Items',
      linkUrl: this.configData.linkUrl,
      recommendationData: this.configData.recommendationData || {},
      useWishList: this.configData.useWishList,
    };
  },
  computed: {
    getConfigData() {
      return {
        ...this.configData,
        recommendationData: this.configData.recommendationData || {},
        useWishList: this.configData.useWishList,
        impressionData: this.impressionData,
        numberOfItems: this.numberOfItems,
        linkName: '',
        linkUrl: '',
        title: '',
      };
    },
  },
  methods: {
    followLink() {
      contentlinkClickEventTag(
        this.configData.recommendationData,
        this.configData.zone,
      );
      window.open(this.configData.linkUrl, '_self');
    },
  },
};
</script>

<style lang="scss" scoped>
.link {
  text-align: right;
}
</style>
